import { render, staticRenderFns } from "./CollectedProductGridItem.vue?vue&type=template&id=0d082f76&"
import script from "./CollectedProductGridItem.vue?vue&type=script&lang=js&"
export * from "./CollectedProductGridItem.vue?vue&type=script&lang=js&"
import style0 from "./CollectedProductGridItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports